<template>
	<div class="recommended-job" @click.prevent="handleClick">

		<p class="recommended-job__section-title">Recommended Job</p>

		<div v-if="recommended_job" class="recommended-job__body">

			<!-- left -->
			<div class="recommended-job__left">
				<div class="recommended-job__logo-container">
					<img class="recommended-job__logo" :src="$filters.analyseImage(recommended_job['org-logo'], 'logosm', 'logoxl')"
						:alt="recommended_job['org-name']" width="54" height="54" loading="lazy"
						onerror="this.onerror=null; this.src='/images/fallback.png'">
				</div>
			</div>

			<!-- right -->
			<div class="recommended-job__right">

				<div class="recommended-job__right-header">
					<h3 v-if="recommended_job['job-title']" class="recommended-job__title"><a
							:href="`/opportunity/redirect/${recommended_job['objectID']}`">{{ recommended_job['job-title'] }}</a></h3>
					<block-action-bookmark-job :job_id="recommended_job['objectID']"></block-action-bookmark-job>
				</div>

				<div class="recommended-job__right-body">
					<!-- org name -->
					<p v-if="recommended_job['org-name']" class="recommended-job__org-name"><a
							:href="`/organisation/redirect/${recommended_job['org-main-id']}`">{{ recommended_job['org-name'] }}</a></p>
					<!-- location -->
					<p v-if="recommended_job['location-txt']" class="recommended-job__location">in
						<span>{{ recommended_job['location-txt']}}</span></p>
				</div>

				<div class="recommended-job__right-footer">
					<!-- salary -->
					<div class="recommended-job__salary-group">
						<div class="recommended-job__salary-icon-container">
							<img class="recommended-job__salary-icon"
								:src="`/images/icons/organisation/salary.svg?${$config.version}`" alt="Salary" loading="lazy">
						</div>

						<p v-if="recommended_job['option-listing-type'] && recommended_job['option-listing-type'].toLowerCase() === 'volunteer'"
							class="recommended-job__salary-text">Volunteer role</p>
						<template v-else>
							<p v-if="recommended_job['salary-low'] !== null && recommended_job['show-sal'] === false"
								class="recommended-job__salary-text estimated">
								<span>From ~ £{{ recommended_job['salary-low'] }}</span>
								<span>(Esc estimated)</span>
							</p>
							<p v-if="recommended_job['salary-low'] !== null && recommended_job['show-sal'] === true"
								class="recommended-job__salary-text verified">
								<span>From £{{ recommended_job['salary-low'] }}</span>
								<span>&#10004; Employer verified</span>
							</p>
							<p v-if="recommended_job['salary-low'] === null" class="recommended-job__salary-text">Please enquire</p>
						</template>
					</div>

					<!-- term -->
					<p v-if="recommended_job['option-term'][0]" class="recommended-job__listing-type">
						<span>{{ recommended_job['option-term'][0] }}</span></p>

					<!-- icons -->
					<div class="recommended-job__right-bottom-icons">
						<div class="recommended-job__right-bottom-icon-container">
							<img src="/images/icons/shared/lady.svg" class="recommended-job__right-bottom-icon" alt="" title="Lady" />
						</div>

						<!-- <div class="recommended-job__right-bottom-icon-container">
            <img src="/images/icons/shared/artboard.svg" class="recommended-job__right-bottom-icon" alt="" title="Art Board"/>
          </div>

          <div class="recommended-job__right-bottom-icon-container">
            <img src="/images/icons/shared/church.svg" class="recommended-job__right-bottom-icon" alt="" title="Church"/>
          </div> -->

						<div class="recommended-job__right-bottom-icon-container">
							<img src="/images/icons/shared/top100.svg" class="recommended-job__right-bottom-icon" alt="Escape Top 100"
								title="Escape Top 100" />
						</div>
					</div>

				</div>

			</div>

		</div>

	</div>
</template>

<script>
import AuthMixins from '@/mixins/AuthMixins';
import RecommendedJobs from '@/mixins/RecommendedJobs';

export default {
	mixins: [AuthMixins, RecommendedJobs],

	data() {
		return {
			recommended_job: false,
		}
	},

	methods: {
		handleClick() {
			if (this.recommended_job) {
				window.location.href = this.calculate_link(this.recommended_job);
			}
		}
	},
}
</script>

